export default __webpack_public_path__ + "static/media/sec3-img.95eff06c.png";